import { AllProjects, LandingEntity } from "utils/projects"
import { StateType } from "../ProjectsLayout"

export type LobbyItem = (AllProjects[number] & { kind?: "project" }) | LandingEntity

const isAnyFilterActive = (filterCategory: keyof StateType, state: StateType) =>
  state[filterCategory].some((filter) => {
    if (filter.number === 0) {
      return false
    }
    return filter.visibility
  })

const getSelectedIds = (filterCategory: keyof StateType, state: StateType) =>
  state[filterCategory].filter((filter) => filter.visibility).map((filter) => filter.number)

export const filterProjects = (projects: LobbyItem[], state: StateType) => {
  return projects?.filter((item) => {
    const selectedStatusIds = getSelectedIds("statuses", state)
    const selectedSubsidiaryIds = getSelectedIds("subsidiaries", state)
    const selectedDesignationIds = getSelectedIds("designations", state)
    const selectedCities = getSelectedIds("cities", state)
    const selectedCountries = getSelectedIds("countries", state)

    const matchesStatuses =
      !isAnyFilterActive("statuses", state) ||
      item.projectStatuses.some((status) => selectedStatusIds.includes(Number(status.id)))
    const matchesSubsidiaries =
      !isAnyFilterActive("subsidiaries", state) ||
      item.groupSites.some((site) => selectedSubsidiaryIds.includes(Number(site.id)))
    const matchesDesignations =
      !isAnyFilterActive("designations", state) ||
      item.propertyDesignations.some((designation) =>
        selectedDesignationIds.includes(Number(designation.id)),
      )
    const matchesCities =
      !isAnyFilterActive("cities", state) ||
      item.city.some((c) => selectedCities.includes(Number(c.id)))
    const matchesCountries =
      !isAnyFilterActive("countries", state) ||
      ("country" in item
        ? item.country.some((c) => selectedCountries.includes(Number(c.id)))
        : true)

    return (
      matchesStatuses &&
      matchesSubsidiaries &&
      matchesDesignations &&
      matchesCities &&
      matchesCountries
    )
  })
}
